import styled from 'styled-components';

export const BannerWrapper = styled.div`
    padding: 1rem;
    &.isBaseDeal {
        padding: 1.14rem 1.14rem 0 1.14rem;
    }
`;
